import moment from "moment";
import Moment from "react-moment";

const calculateTime = (createdAt) => {
  const today = moment(Date.now());
  const postDate = moment(createdAt);
  const diffInHours = today.diff(postDate, "hours");
  if (diffInHours < 24) {
    return (
      <>
        <Moment format="hh:mm">{createdAt}</Moment>
      </>
    );
  } else if (diffInHours > 24 && diffInHours < 36) {
    return (
      <>
        Yesterday <Moment format="hh:mm">{createdAt}</Moment>
      </>
    );
  } else if (diffInHours > 36) {
    return <Moment format="D MMMM">{createdAt}</Moment>;
  }
};

export const getLocalFormatedTime = (utcDate, format = "HH:mm") => {
  let returnValue = "";
  if (moment(utcDate).isValid()) {
    switch (format) {
      case "CHATLIST":
        const diffInHours = moment().diff(utcDate, "hours");
        const preFix = diffInHours < 36 ? diffInHours < 24 ? "" : "Yesterday" : "";
        const chatListFormat = diffInHours > 36 ? "D MMMM" : "HH:mm";
        returnValue = moment.utc(utcDate).local().format(`[${preFix}] ${chatListFormat}`).trim();
        break;
      default:
        returnValue = moment.utc(utcDate).local().format(format);
        break;
    }
  }
  return returnValue;
}
export const formattedCurrency = (amount) => {
  if (!amount) return;
  return new Intl.NumberFormat("nl-NL", { currency: "EUR", style: "currency", currencyDisplay: 'narrowSymbol' }).format(amount);
}


export default calculateTime;
